import React from 'react';

const About = () => {
  return (
    <div>
      {/* Sayfa Başlığı Banner */}
      <div className="bg-primary text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-4xl font-bold">Hakkımızda</h1>
          <p className="mt-4 text-xl">Cihangir Nakliyat Hikayesi</p>
        </div>
      </div>

      {/* Biz Kimiz Bölümü */}
      <section className="py-16">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <h2 className="section-title">Biz Kimiz?</h2>
            <p className="text-gray-700 mb-6">
              Cihangir Nakliyat, 15 yılı aşkın süredir taşımacılık sektöründe güvenilir bir isim olarak hizmet vermektedir. Müşteri odaklı yaklaşımımız, profesyonel ekibimiz ve yenilikçi çözümlerimizle, her türlü taşıma ihtiyacınıza en iyi şekilde cevap veriyoruz. Türkiye'nin her köşesine uzanan hizmet ağımızla, eşyalarınıza sizin kadar değer veriyoruz.
            </p>
            
            <p className="text-gray-700 mb-6">
              Yılların verdiği tecrübe ve sürekli gelişen teknolojik altyapımızla, taşımacılık hizmetini en üst seviyeye çıkarmak için çalışıyoruz. Ev taşıma, ofis taşıma, asansörlü taşıma, depolama ve şehirler arası taşıma hizmetlerimizle, müşterilerimizin hayatını kolaylaştırıyoruz.
            </p>
            <p className="text-gray-700">
              Cihangir Nakliyat ailesi olarak, her müşterimize özel çözümler sunuyor, taşınma sürecini sizin için sorunsuz ve keyifli hale getiriyoruz. Çünkü biliyoruz ki, sizin için değerli olan her şey, bizim için de değerli.
            </p>
          </div>
        </div>
      </section>

      {/* Misyon ve Vizyon */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Misyon */}
            <div className="bg-white p-8 rounded-lg shadow-md">
              <h2 className="section-title">Misyonumuz</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Cihangir Nakliyat olarak misyonumuz, müşterilerimize taşımacılık sektöründe mükemmelliği sunmaktır. Güvenilirlik, profesyonellik ve müşteri odaklı yaklaşımımızla, her taşınma sürecini sorunsuz bir deneyime dönüştürmeyi amaçlıyoruz. Sürekli gelişim ilkemiz doğrultusunda, en son teknolojiler ve yenilikçi çözümlerle hizmet kalitemizi sürekli yükseltiyoruz.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Eşyalarınızın güvenliği ve bütünlüğü, bizim için en büyük önceliktir. Bu nedenle, her detayı titizlikle planlıyor, her aşamada en yüksek kalite standartlarını uyguluyoruz. Müşteri memnuniyetini her şeyin üzerinde tutarak, taşımacılık deneyiminizi stressiz ve keyifli hale getirmek için çalışıyoruz.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Kurumsal ve bireysel her müşterimize özel çözümler sunarak, ihtiyaçlarınızı anlamak ve beklentilerinizi aşmak için buradayız. Nakliyat sürecinizde güvenilir iş ortağınız olmayı ve uzun vadeli ilişkiler kurmayı hedefliyoruz.
              </p>
              <div className="mt-6 flex justify-center">
                <div className="bg-primary bg-opacity-10 w-20 h-20 rounded-full flex items-center justify-center">
                  <svg className="w-10 h-10 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
              </div>
            </div>
            
            {/* Vizyon */}
            <div className="bg-white p-8 rounded-lg shadow-md">
              <h2 className="section-title">Vizyonumuz</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Cihangir Nakliyat olarak vizyonumuz, Türkiye'nin nakliyat sektöründe lider ve yenilikçi bir firma olarak, sektör standartlarını belirleyen ve sürekli yükselten bir konumda yer almaktır. Tüm paydaşlarımız için değer yaratarak, sürdürülebilir büyüme sağlamayı ve taşımacılık alanında referans noktası olmayı hedefliyoruz.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Teknolojik yenilikleri yakından takip ederek, dijital dönüşüm süreçlerimizi hızlandırmayı ve operasyonel mükemmelliği sağlamayı amaçlıyoruz. Çevre dostu uygulamalar ve sosyal sorumluluk projeleriyle, topluma ve doğaya katkı sağlayan bir şirket kültürü oluşturmak vizyonumuzun ayrılmaz bir parçasıdır.
              </p>
              <p className="text-gray-700 leading-relaxed">
                İnsan kaynaklarımızın sürekli gelişimini destekleyerek, sektörün en yetkin ve profesyonel ekibini bünyemizde barındırmayı ve müşterilerimize kesintisiz bir memnuniyet sağlamayı taahhüt ediyoruz. Müşterilerimizin bizi sadece bir nakliyat firması olarak değil, güvenilir bir danışman ve çözüm ortağı olarak görmelerini sağlamak için durmaksızın çalışıyoruz.
              </p>
              <div className="mt-6 flex justify-center">
                <div className="bg-primary bg-opacity-10 w-20 h-20 rounded-full flex items-center justify-center">
                  <svg className="w-10 h-10 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Kurumsal Değerlerimiz Bölümü - Yeni Eklenen */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <h2 className="section-title text-center mb-10">Kurumsal Değerlerimiz</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="bg-primary bg-opacity-10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-primary mb-3">Güven</h3>
              <p className="text-gray-700">
                Müşterilerimizle kurduğumuz ilişkilerin temelinde güven yatar. Verdiğimiz her sözü tutarak ve şeffaf bir iletişim kurarak bu güveni her gün yeniden inşa ediyoruz.
              </p>
            </div>
            <div className="text-center p-6">
              <div className="bg-primary bg-opacity-10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-primary mb-3">Kalite</h3>
              <p className="text-gray-700">
                Her işimizde en yüksek kalite standartlarını uyguluyor, sürekli iyileştirme ve geliştirme ile hizmetlerimizi mükemmelleştiriyoruz.
              </p>
            </div>
            <div className="text-center p-6">
              <div className="bg-primary bg-opacity-10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-primary mb-3">Zamanında Teslimat</h3>
              <p className="text-gray-700">
                Müşterilerimizin zamanının değerli olduğunu biliyor, planlanan takvime sadık kalarak, dakik ve güvenilir bir hizmet sunuyoruz.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 